const getWorkingDayEnd = (date = new Date(), hours = 4, minutes = 59, seconds = 59) => {
	return new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1, hours, 59, 59, 0)
}

export default getWorkingDayEnd
